import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=30ea3778&lang=html"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=30ea3778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports